<template>
  <div>
    <div class="row justify-content-center">
       <div class="col-10">
                <div class="text-left section-title" style="padding: 5px;">
                <span class="row-table-font-margins" style='font-family: inherit; font-weight: 600 ; line-height: 1; text-align:center'>{{$t("real_estate")}}</span>
                </div>
            </div>
     
    </div>

    <div class="row" style="padding-left: 15px; padding-right: 15px;">
      <div class="col-6 offset-3">
          <div class="container form-background">
              <div class="row">
                  <div class=" col-12 text-left form-title">
                      <span class="row-table-font-margins">{{ formTitle }}</span>
                  </div>
              </div>
              <div v-if="id == 0" class="row">
                  <div class="col-md-6">
                      <label>Type</label>
                      <div class="input-group-append">
                          <div class="input-group-text radio-toolbar">
                              <label>Complex</label><input v-model="unitType" value="complex" name="optradio" type="radio" checked>
                          </div>
                          <div class="input-group-text radio-toolbar">
                              <label>Building</label><input v-model="unitType" value="building" name="optradio" type="radio">
                          </div>
                          <div class="input-group-text radio-toolbar">
                              <label>Property</label><input v-model="unitType" value="property" name="optradio" type="radio">
                          </div>
                      </div>
                  </div>
              </div>
              <template v-if="isProperty">
                  <div class="row">
                      <div class="col-md-6">
                          <label>Unit Number: *</label>
                          <input type="text"
                                 placeholder="Number"
                                 class="form-control"
                                 v-model="number" />
                          <div v-show="submitted && !number" class="invalid-feedback">
                              Unit number is required
                          </div>
                      </div>
                      <div class="col-md-6">
                          <label>Floor:  *</label>
                          <select class="form-control" v-model="floor">
                              <option value="LG">LG</option>
                              <option value="G">G</option>
                              <option value="M">M</option>
                              <option value="1">1</option>
                              <option value="2">2</option>
                              <option value="3">3</option>
                              <option value="4">4</option>
                              <option value="5">5</option>
                              <option value="6">6</option>
                              <option value="7">7</option>
                              <option value="8">8</option>
                              <option value="9">9</option>
                              <option value="10">10</option>
                          </select>
                          <div v-show="submitted && !floor" class="invalid-feedback">
                              Floor is required
                          </div>
                      </div>
                  </div>

                  <div class="row">
                      <div class="col-md-6">
                          <label>Type:  *</label>
                          <select class="form-control" v-model="type">
                              <option value="1">Flat</option>
                              <option value="2">Shop</option>
                              <option value="3">Office</option>
                          </select>
                          <div v-show="submitted && !type" class="invalid-feedback">
                              Type is required
                          </div>
                      </div>
                      <div class="col-md-6">
                          <label>Square Meters:</label>
                          <input style="width: 100%;"
                                 type="number"
                                 placeholder="Square Meters"
                                 class="form-control"
                                 v-model="squareMeters" />
                      </div>
                  </div>


                  <div class="row">
                      <div class="col-md-6">
                          <label>Monthly fee:</label>
                          <input style="width: 100%;"
                                 type="number"
                                 placeholder="Monthly Fee"
                                 class="form-control"
                                 v-model="monthlyFee" />
                      </div>
                      <div class="col-md-6">
                          <label>Starting From:</label>
                          <select name="startingMonth" v-model="startingMonth" id="" class="form-control">
                              <option v-for="(month,index) in months" :key="index" :value=month.id>{{month.name}}</option>
                          </select>
                      </div>
                  </div>

                  <div class="row">
                      <div class="col-md-6">
                          <label>Full Name:  *</label>
                          <input type="text"
                                 name="name"
                                 v-model="contact.name"
                                 placeholder="Full Name"
                                 class="form-control" />
                          <div v-show="submitted && !contact.name"
                               class="invalid-feedback ">
                              Contact name is required
                          </div>
                      </div>
                      <div class="col-md-6">
                          <label>Email:  *</label>
                          <input type="email"
                                 name="email"
                                 v-model="contact.email"
                                 placeholder="Email"
                                 class="form-control" />
                          <div v-show="submitted && !contact.email"
                               class="invalid-feedback ">
                              Contact email is required
                          </div>
                      </div>
                  </div>

                  <div class="row">
                      <div class="col-md-6">
                          <label>Phone number:  *</label>
                          <input type="text"
                                 name="phone_number"
                                 v-model="contact.phoneNumber"
                                 placeholder="Phone Number"
                                 class="form-control" />
                          <div v-show="submitted && !contact.phoneNumber"
                               class="invalid-feedback ">
                              Contact phone number is required
                          </div>
                      </div>
                      <div class="col-md-6">
                          <label>Management Company:  </label>
                          <input type="text"
                                 name="managementCompany"
                                 v-model="managementCompany"
                                 placeholder="Management Company"
                                 class="form-control" />
                      </div>
                  </div>

                  <div class="row">
                      <div class="col-md-6">
                          <label>Contact Person:  </label>
                          <input type="text"
                                 name="contactPerson"
                                 v-model="contactPerson"
                                 placeholder="Contact Person"
                                 class="form-control" />
                      </div>
                      <div class="col-md-6">
                          <label>Phone Number:  </label>
                          <input type="text"
                                 name="phoneNumber"
                                 v-model="phoneNumber"
                                 placeholder="Phone Number"
                                 class="form-control" />
                      </div>
                  </div>

                  

                  <div class="row">
                      <div class="panel-body table-responsive">
                          <template v-for="post in propertyHistory">
                              <div class="row">
                                  <div class="col-md-3">
                                      <label>Year</label>
                                      <input class="form-control text-right"
                                             v-model="post.year"
                                             number />
                                  </div>
                                  <div class="col-md-3">
                                      <label>Total to Pay</label>
                                      <input class="form-control text-right"
                                             v-model="post.statement"
                                             number
                                             data-type="currency" />
                                  </div>
                                  <div class="col-md-3">
                                      <label>Paid</label>
                                      <input class="form-control text-right"
                                             v-model="post.paid"
                                             number
                                             data-type="currency" />
                                  </div>
                                  <div class="col-md-3">
                                      <label>Balance</label>
                                      <input class="form-control text-right"
                                             :value="post.statement - post.paid"
                                             number
                                             readonly
                                             data-type="currency" />
                                  </div>

                              </div>
                          </template>

                          <input type="hidden"
                                 id="items"
                                 name="propertyHistory"
                                 v-model="propertyHistory" />
                      </div>
                  </div>
              </template>
              <template v-else>
                  <div class="row">
                      <div class="col-md-6">
                          <label>Street Name: *</label>
                          <input type="text" v-model="building.streetName" placeholder="Street name" class="form-control" />
                          <div v-show="submitted && !building.streetName" class="invalid-feedback">
                              Street name is required
                          </div>
                      </div>
                      <div class="col-md-6">
                          <label>{{ buildingNameLabel }}: *</label>
                          <input type="text" v-model="building.name" :placeholder="buildingNameLabel" class="form-control" />
                          <div v-show="submitted && !building.name" class="invalid-feedback">
                              Building name is required
                          </div>
                      </div>
                  </div>

                  <div class="row">
                      <div class="col-md-6">
                          <label>City: *</label>
                          <input type="text" v-model="building.city" placeholder="City" class="form-control" />
                          <div v-show="submitted && !building.city" class="invalid-feedback">
                              City is required
                          </div>
                      </div>
                      <div class="col-md-6">
                          <label>Number: *</label>
                          <input type="text" v-model="building.number" placeholder="Number" class="form-control" />
                          <div v-show="submitted && !building.number" class="invalid-feedback">
                              Number is required
                          </div>
                      </div>
                  </div>

                  <div class="row">
                      <div class="col-md-6">
                          <label>Opening Balance: </label>
                          <input type="number" placeholder="Opening Balance" v-model="building.openingBalance" number data-type="currency" class="form-control" />
                      </div>
                      <div class="col-md-6">
                          <label>Postcode: *</label>
                          <input type="text" v-model="building.postCode" placeholder="Postcode" class="form-control" />
                          <div v-show="submitted && !building.postCode" class="invalid-feedback">
                              Post code is required
                          </div>
                      </div>
                  </div>

                  <div class="row">
                      <div class="col-md-6">
                          <label>Registration Year: *</label>
                          <select v-model.number="building.registrationYear" class="form-control" aria-label="Registration year">
                              <option v-for="year in registrationYears" :key="year" :value="year">{{ year }}</option>
                          </select>
                          <small class="text-muted">The first year with data for this building. Reports offer years from here.</small>
                          <div v-show="submitted && !building.registrationYear" class="invalid-feedback">Registration year is required</div>
                      </div>
                  </div>
                  
                  <div class="row">
                      <div class="col-md-6">
                          <label>Use Monthly Expenses:</label>
                          <input type="checkbox"
                                 name="useMonthlyExpenses"
                                 v-model="building.useMonthlyExpenses" />
                      </div>

                  </div>

              </template>

                  <!-- <div v-if="!isPartOfComplex"
          class="form-group"
          style="padding-left: 15px; padding-right: 15px;"
        >
          <strong>Is Complex: </strong>
          <input
            type="checkbox"
            v-model="building.isComplex"
            class="form-check-input"
          />
        </div> -->



                  <input type="hidden" name="user_id" value="user_id" />
                  <section id="complexes" style="display: none;"></section>
          </div>
         <div class="text-right">
          <button type="submit" @click="submit()" class="btn btn-submit" style="margin: 15px;">
            Submit
          </button>
          <button @click="cancel()" class="btn btn-cancel">Cancel</button>
        </div>
      </div>
     
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import { authenticationService, buildingService } from "@/_services";
export default {
  data: function () {
    return {
      formTitle: "Add New Real Estate",
      id: 0,
      complexId: 0,
      complexName: "",
      submitted: false,
      currentUser: null,
      userId: 0,
        routeName: "buildings",
        unitType: "building",
        buildingNameLabel: "Building Name",
        number: "",
        monthlyFee: 0,
        type: 1,
        squareMeters: 0,
        startingMonth: 1,
        managementCompany: "",
        contactPerson: "",
        phoneNumber: "",
        floor: "LG",
        contact: {},
        renterContact: {},
        propertyHistory: [],
        users: [],
        contactId: null,
        renterContactId: null,
        months: [],
        useMonthlyExpenses: false,
        building: {},
    };
        },
        watch: {
            // edit a local copy so the store (and the buildings list) only change after a successful save
            storeBuilding: {
                handler(val) {
                    if (this.id && val && val.id == this.id)
                        this.building = JSON.parse(JSON.stringify(val));
                },
            },
            unitType(newValue){
                if (newValue == "building")
                    this.buildingNameLabel = "Building Name"
                if (newValue == "complex")
                    this.buildingNameLabel = "Complex Name"
            }
        },
  created() {
    authenticationService.currentUser.subscribe((x) => (this.currentUser = x));
  },
  mounted() {
    if (this.$route.params.id) {
      this.formTitle = "Edit Real Estate";
      this.id = this.$route.params.id;
      this.fetchBuilding(this.id);
      if (this.storeBuilding && this.storeBuilding.id == this.id)
        this.building = JSON.parse(JSON.stringify(this.storeBuilding));
    } else {
      this.building = { registrationYear: new Date().getFullYear() };
    }

    if (this.$route.params.userId) this.userId = this.$route.params.userId;
    else this.userId = this.currentUser.id;

    if (this.$route.params.routeName)
      this.routeName = this.$route.params.routeName;

    if (this.$route.params.complexId) {
      this.complexId = this.$route.params.complexId;
      this.complexName = this.$route.params.complexName;
      }
      this.getMonths();
      this.contact = { name: "", phoneNumber: "", email: "" };
  },
  computed: {
    registrationYears() {
      const current = new Date().getFullYear();
      const years = [];
      for (let year = current; year >= 1990; year--) years.push(year);
      return years;
    },
    ...mapState({
      storeBuilding: (state) => state.building.currentBuilding,
    }),
    isPartOfComplex() {
      return this.complexId > 0;
      },
      isProperty() {
          return this.unitType == "property"
      }
  },
  methods: {
      ...mapActions("building", ["fetchBuilding", "createFreshBuilding"]),
      getMonths: function () {
          this.mute = true;
          //this.buildingId = 3;
          var request = "/months";
          this.$http
              .get(request, {
                  id: this.buildingId,
              })
              .then((response) => {
                  this.mute = false;

                  //this.contacts = data.contacts;
                  this.months = response.data.months;
              });
      },
      submit: function () {
          if (this.unitType == "property") {
              var canSubmit =
                  this.number &&
                  this.floor &&
                  this.type &&
                  this.contact.name &&
                  this.contact.email &&
                  this.contact.phoneNumber;
              if (this.id && !this.isClone) {
                  this.submitted = true;

                  if (canSubmit)
                      this.$http
                          .put("/properties/" + this.id, {
                              id: this.id,
                              number: this.number,
                              monthlyFee: this.monthlyFee,
                              startingMonth: this.startingMonth,
                              type: this.type,
                              squareMeters: this.squareMeters,
                              floor: this.floor,
                              buildingId: this.buildingId,
                              contact: this.contact,
                              renterContact: this.renterContact,
                              contactId: this.contactId,
                              renterContactId: this.renterContactId,
                              propertyHistories: this.propertyHistory,
                              managementCompany: this.managementCompany,
                              contactPerson: this.contactPerson,
                              phoneNumber: this.phoneNumber,
                              userId: this.userId,
                          })
                          .then(
                              () => {
                                  this.$router.push("/buildings");
                              },
                              () => {
                                  alert("error");
                                  //  this.infoError = true
                                  //  this.loader = false
                                  //   this.password = ''
                              }
                          );
              } else {
                  this.submitted = true;
                  if (canSubmit)
                      this.$http
                          .post("/properties", {
                              number: this.number,
                              monthlyFee: this.monthlyFee,
                              startingMonth: this.startingMonth,
                              type: this.type,
                              squareMeters: this.squareMeters,
                              floor: this.floor,
                              buildingId: this.buildingId,
                              contact: this.contact,
                              contactId: this.contactId,
                              renterContactId: this.renterContactId,
                              renterContact: this.renterContact,
                              propertyHistories: this.propertyHistory,
                              managementCompany: this.managementCompany,
                              contactPerson: this.contactPerson,
                              phoneNumber: this.phoneNumber,
                              userId: this.userId,
                              //   contact:this.contact
                          })
                          .then(
                              () => {
                                  this.$router.push("/buildings");
                              },
                              () => {
                                  alert("error");
                                  //  this.infoError = true
                                  //  this.loader = false
                                  //   this.password = ''
                              }
                          );
              }
          }
          else {
              var canSubmit =
                  this.building.name &&
                  this.building.streetName &&
                  this.building.number &&
                  this.building.city &&
                  this.building.postCode &&
                  this.building.registrationYear;
              if (this.id) {
                  this.submitted = true;
                  if (canSubmit)
                      buildingService
                          .updateBuilding(
                              this.building.id,
                              this.building.name,
                              this.building.streetName,
                              this.building.number,
                              this.building.city,
                              this.building.postCode,
                              this.building.isComplex,
                              this.building.openingBalance,
                              this.building.complexId,
                              this.building.useMonthlyExpenses,
                              this.building.registrationYear
                          )
                          .then(
                              () => {
                                  this.$store.commit("building/SET_CURRENT_BUILDING", JSON.parse(JSON.stringify(this.building)));
                                  if (this.building.complexId)
                                      this.$router.push({
                                          name: "complex",
                                          params: {
                                              buildingId: this.building.complexId,
                                              buildingName: this.complexName,
                                          },
                                      });
                                  else this.$router.push("/buildings");
                              },
                              () => {
                                  alert("error");
                                  //  this.infoError = true
                                  //  this.loader = false
                                  this.password = "";
                              }
                          );
              } else {
                  this.submitted = true;
                  if (canSubmit)
                      buildingService
                          .addBuilding(
                              this.building.name,
                              this.building.streetName,
                              this.building.number,
                              this.building.city,
                              this.building.postCode,
                              this.userId,
                              this.unitType == "complex" ? true : false,//,
                              this.building.openingBalance,
                              this.complexId,
                              this.building.useMonthlyExpenses,
                              this.building.registrationYear
                          )
                          .then(
                              () => {
                                  if (this.complexId)
                                      this.$router.push({
                                          name: "complex",
                                          params: {
                                              buildingId: this.complexId,
                                              buildingName: this.complexName,
                                          },
                                      });
                                  else this.$router.push("/buildings");
                              },
                              () => {
                                  alert("error");
                                  //  this.infoError = true
                                  //  this.loader = false
                                  this.password = "";
                              }
                          );
              }
          }
    },
    cancel() {
      if (this.complexId)
        this.$router.push({
          name: "complex",
          params: {
            buildingId: this.complexId,
            buildingName: this.complexName,
          },
        });
      else this.$router.push("/buildings");
    },
  },
};
</script>
